<template>
  <div class="order-confirm">
    <div class="page-title">确认订单</div>
    <div v-if="address.telephone" class="address" @click="addressSelect">
      <div class="address-left">
        <div class="address-icon"><i class="outline el-icon-location-information"></i></div>
        <div class="address-content">
          <div class="name-phone">
            {{ address.consignee }} <span style="margin-left:15px;">{{ address.telephone }}</span>
          </div>
          <div class="address-detail">{{ addressStr ||  (address.provinceName + address.cityName + address.areaName + address.detailAddress) }}</div>
        </div>
      </div>
      <div class="address-right">></div>
    </div>
    <div v-else class="address" style="justify-content: center" @click="addressSelect">
      请选择地址
    </div>
    <div class="buy-detail">
      <img class="ip-img" :src="ipImgUrl" alt="" />
      <div class="buy-content">
        <div>{{ code == 1 ? '国内防伪码' : '国外防伪码' }}</div>
        <div>
          购买数量： <span style="color:#888;">{{ count }}</span>
        </div>
        <div>
          总价： <span style="color:#F56C6C;">￥{{ total }}</span>
        </div>
      </div>
    </div>
    <div class="buy-detail">
      <el-form label-width="160px">
        <el-form-item label="品牌及艺术家联名名称">
          <el-input :disabled="!!orderNo && !edit" v-model="brandName" placeholder="例：海澜之家&梵高" />
        </el-form-item>
        <el-form-item label="产品预计上市时间">
          <el-input :disabled="!!orderNo && !edit" v-model="publishDate" placeholder="例：2022年春季或2022年1月至3月" />
        </el-form-item>
        <el-form-item label="产品类别/名称">
          <el-input :disabled="!!orderNo && !edit" v-model="ipApply" placeholder="例：鞋盒/鞋子、服装/卫衣、 服装/连衣裙、 帽子、等" />
        </el-form-item>
        <el-form-item label="IP衍生商品销售渠道">
          <el-input :disabled="!!orderNo && !edit" v-model="ipChannel" placeholder="例：线上淘宝京东天猫或线下实体店等" />
        </el-form-item>
        <el-form-item label="最终设计图">
          <myUpload accept="image/png" :disabled="!!orderNo && !edit" info="仅支持png, 小于20M" :imgKey.sync="designImgKey" :url="designImgUrl" />
        </el-form-item>
      </el-form>
    </div>
    <div class="buy-option" v-if="!edit">
      <div class="title" style="margin-top:20px;">支付方式</div>
      <el-radio-group v-model="payType">
        <div class="radio-option">
          <el-radio :label="1"><el-tag type="primary">支付宝支付</el-tag></el-radio>
        </div>
        <div class="radio-option">
          <el-radio :label="2"><el-tag type="success">微信支付</el-tag></el-radio>
        </div>
        <div class="radio-option">
          <el-radio :label="4"><el-tag type="primary">线下支付</el-tag></el-radio>
        </div>
      </el-radio-group>
    </div>
    <el-button :loading="payLoading" v-if="edit" type="primary" style="width:100%;" @click="submitInfo">提交信息</el-button>
    <el-button :loading="payLoading" v-if="!orderNo && !edit" type="primary" style="width:100%;" @click="submitOrder">提交订单</el-button>
    <el-button v-if="orderNo && !edit" type="primary" :loading="payLoading" style="width:100%;" @click="pay">立即支付</el-button>
    <el-dialog width="500px" title="支付" :visible.sync="payVisible" :close-on-click-modal="false" @close="payClose" append-to-body>
      <div v-if="payType == offlinePaytype" class="pay-wrap">
        线下转账成功后请联系客服确认！
      </div>
      <div v-else class="pay-wrap">
        <img :src="payQcore" alt="" />
        <div class="info">请使用{{ payType == 1 ? '支付宝' : '微信' }}扫码支付</div>
      </div>
      <span v-if="payType == offlinePaytype" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goBack">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '../lib/API'
import QRCode from 'qrcode'
import MyUpload from '../components/common/MyUpload.vue'
export default {
  name: 'OrderList',
  components: {
    MyUpload
  },
  data() {
    return {
      payType: 1,
      count: '',
      total: '',
      ipImgUrl: '',
      code: '',
      address: {},
      addressStr: '',
      brandName: '',
      designImgKey: '',
      designImgUrl: '',
      payQcore: '',
      payVisible: false,
      payLoading: false,
      orderNo: '',
      orderId: '',
      // 线下支付
      offlinePaytype: 4,
      timer: null,
      selectAddressId: '',
      publishDate: '',
      ipApply: '',
      ipChannel: ''
    }
  },
  computed: {
    categoryDisabled() {
      if (this.dataType === '1' || (this.dataType === '2' && this.shopId)) {
        return false
      }
      return true
    }
  },
  beforeDestroy() {
    this.payClose()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    payClose() {
      this.timer && clearTimeout(this.timer)
    },
    submitInfo() {
      this.payLoading = true
      new API(this).POST({
        url: '/iporder/submitCheckInfo',
        params: {
          brandName: this.brandName,
          designImgKey: this.designImgKey,
          publishDate: this.publishDate,
          ipApply: this.ipApply,
          ipChannel: this.ipChannel,
          orderNo: this.orderNo
        },
        cb: res => {
          this.$router.back()
        },
        errCb: err => {
          this.payLoading = false;
        }
      })
    },
    submitOrder() {
      if (!this.address.telephone) {
        return this.$message.error('请选择地址')
      }
      if (!this.brandName) {
        return this.$message.error('请输入品牌及艺术家联名名称')
      }
      if (!this.publishDate) {
        return this.$message.error('请输入产品预计上市时间')
      }
      if (!this.designImgKey) {
        return this.$message.error('请输入最终设计图')
      }
      this.payLoading = true
      let { provinceName, cityName, areaName, detailAddress, consignee, telephone } = this.address

      new API(this).POST({
        url: '/iporder/commitOrder',
        params: {
          address: provinceName + cityName + areaName + detailAddress,
          buyer: consignee,
          count: this.count,
          designId: this.designId,
          // payType: this.payType,
          phoneNumber: telephone,
          price: this.price,
          brandName: this.brandName,
          designImgKey: this.designImgKey,
          publishDate: this.publishDate,
          ipApply: this.ipApply,
          ipChannel: this.ipChannel
        },
        cb: res => {
          this.orderNo = res.no
          this.orderId = res.id
          this.payLoading = false
          this.pay()
        },
        errCb: err => {
          this.payLoading = false;
        }
      })
    },
    addressSelect() {
      if (this.orderNo) {
        return this.$message.error('订单已生成不能修改地址');
      }
      this.$router.push({ name: 'Address', query: { addressId: this.address.id || '' } })
    },
    pay() {
      this.payLoading = true
      if (this.payType == this.offlinePaytype) {
        // 线下支付
        new API(this).POST({
          url: '/iporder/offlinePay',
          params: {
            orderNo: this.orderNo
          },
          cb: res => {
            this.payLoading = false
            this.payVisible = true
          },
          errCb: err => {
            this.payLoading = false
          }
        })
      } else {
        new API(this).POST({
          url: '/iporder/payCodeUrl',
          params: {
            payType: this.payType,
            orderNo: this.orderNo,
            orderId: this.orderId
          },
          cb: res => {
            this.payLoading = false
            QRCode.toDataURL(res.alipayQcore || res.wxQcore, (err, url) => {
              this.payQcore = url
              this.payVisible = true
              this.payLoading = false
            })
            this.queryPayResult()
          },
          errCb: err => {
            this.payLoading = false
          }
        })
      }
    },
    queryPayResult() {
      this.timer = setTimeout(() => {
        new API(this).POST({
          url: '/iporder/payResult',
          params: {
            orderNo: this.orderNo,
            orderId: this.orderId
          },
          cb: res => {
            if (res.status == 1) {
              this.$notify({
                title: '支付成功',
                type: 'success',
                duration: 2000
              })
              this.goBack()
            } else {
              this.queryPayResult()
            }
          }
        })
      }, 1000)
    }
  },
  created() {
    let { publishDate, ipApply, edit, ipChannel, count, total, code, ipImgUrl, designId, price, orderNo, orderId, address, consignee, telephone, designImgUrl, brandName } = this.$route.query
    this.count = count
    this.total = total
    this.publishDate = publishDate
    this.edit = edit
    this.ipApply = ipApply
    this.ipChannel = ipChannel
    this.code = code
    this.ipImgUrl = ipImgUrl
    this.designId = designId
    this.price = price
    this.orderId = orderId
    this.orderNo = orderNo
    this.addressStr = address
    this.address.telephone = telephone
    this.address.consignee = consignee
    this.designImgUrl = designImgUrl
    this.brandName = brandName
    // 判断是否从选择地址页面回退回来
    this.selectAddressId = localStorage.getItem('selectAddressId')
    if (this.selectAddressId) {
      new API(this).POST({
        url: `/address/getAddressDetail?id=${this.selectAddressId}`,
        cb: res => {
          this.address = res
        }
      })
      localStorage.removeItem('selectAddressId')
    } else {
      if (!this.addressStr) {
        new API(this).POST({
          url: '/address/getDefaultAddress',
          cb: res => {
            this.address = res || {}
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.pay-wrap {
  padding-bottom: 30px;
  font-size: 20px;
  text-align: center;
  .info {
    text-align: center;
    font-size: 14px;
  }
  img {
    display: block;
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
  }
}

.order-confirm {
  width: 600px;
  margin: 0 auto;
  background: #f1f1f1;
  min-height: 500px;
  border-radius: 10px;
  padding: 10px 30px 30px;
  /deep/ .el-input {
    width: 360px!important;
  }
  .page-title {
    font-size: 16px;
    font-weight: bold;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin-bottom: 10px;
  }
  .address {
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    align-items: center;
    cursor: pointer;
    .address-left {
      display: flex;
      align-items: center;
      .address-icon {
        font-size: 30px;
      }
      .address-content {
        margin-left: 20px;
        width: 280px;
        .name-phone {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
      }
    }
  }
  .buy-detail {
    display: flex;
    padding: 15px;
    background: #fff;
    margin-top: 10px;
    border-radius: 10px;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    .ip-img {
      width: 90px;
      height: 90px;
      margin-right: 20px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
    }
    .buy-content {
      line-height: 30px;
    }
  }
  .buy-option {
    margin-bottom: 20px;
    .title {
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: bold;
    }
    .radio-option {
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderConfirm.vue